module.exports = __webpack_public_path__ + "static/media/avatar34.507ae0a4.png";